.wrapper {
  padding-top: rem(60px);
  padding-bottom: rem(60px);
  margin-bottom: rem(60px);
  position: relative;
  box-sizing: border-box;
  background-color: light-dark(
    var(--mantine-color-gray-1),
    var(--mantine-color-dark-8)
  );
  border-radius: var(--mantine-radius-lg);
}

.inner {
  position: relative;
}

.title {
  font-size: rem(62px);
  font-weight: 900;
  line-height: 1.1;
  margin: 0;
  padding: 0;
  color: light-dark(var(--mantine-color-black), var(--mantine-color-white));

  @media (max-width: $mantine-breakpoint-sm) {
    font-size: rem(42px);
    line-height: 1.2;
  }
}

.description {
  margin-top: var(--mantine-spacing-xl);
  font-size: rem(24px);

  @media (max-width: $mantine-breakpoint-sm) {
    font-size: rem(18px);
  }
}

.controls {
  margin-top: calc(var(--mantine-spacing-xl) * 2);

  @media (max-width: $mantine-breakpoint-sm) {
    margin-top: var(--mantine-spacing-xl);
  }
}

.control {
  height: rem(54px);
  padding-left: rem(38px);
  padding-right: rem(38px);

  @media (max-width: $mantine-breakpoint-sm) {
    height: rem(54px);
    padding-left: rem(18px);
    padding-right: rem(18px);
    flex: 1;
  }
}

.dots {
  position: absolute;
  color: light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-6));

  @media (max-width: $mantine-breakpoint-sm) {
    display: none;
  }
}
